var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-inline-block ml-1"},[(_vm.currency === 'EUR')?_c('span',[_vm._v("€")]):(_vm.currency === 'USD')?_c('span',[_vm._v("$")]):(_vm.currency === 'GBP')?_c('span',[_vm._v("£")]):_c('span',[_c('i',{staticClass:"fas fa-question-circle"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }